import { GenericResponseData } from './../generic-response';
import { baseUrl } from './../../../global-variables';
import {
  CategoryListResponce,
  DeleteVoteFaqResponce,
  FaqAnswerResponce,
  FaqSubCategoryListResponce,
  messageBadge,
  messageInboxResponce,
  SearchFaqResponse,
  SendVoteFaqResponce,
  SuppotTicketsResponce,
  UpdateMessageResponce,
} from './../../../core/model/api-response/support-responce.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GenericResponse } from '../generic-response';
import { UserDataService } from '../user-repository/user-data.service';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';

@Injectable({
  providedIn: 'root',
})
export class SupportApiService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private userRefreshTokenService: UserRefreshTokenService
  ) {}

  getCategories(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<CategoryListResponce>(baseUrl + 'api/v2/faq/category/list', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        if (res.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({ supportCategories: res })
          );
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getCategories();
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  getSubCategories(id: string): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<FaqSubCategoryListResponce>(
        baseUrl + 'api/v2/faq/getFAQBySubcategory/' + id,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        if (res.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({ faqSubCategories: res })
          );
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getSubCategories(id);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  getSearchResult(query: string): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<SearchFaqResponse>(baseUrl + 'api/v2/faq/search?query=' + query, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ faqSearchResponce: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getSearchResult(query);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  getFaqAnswer(id: string): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<FaqAnswerResponce>(baseUrl + 'api/v2/faq/' + id, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ faqAnswerResponce: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getFaqAnswer(id);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  getMessageInbox(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<messageInboxResponce>(baseUrl + 'api/v2/supportTicket/user', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ messageInboxResponce: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getMessageInbox();
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  getMessageBadge(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<messageBadge>(baseUrl + 'api/v2/supportTicket/user/badge', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ messageBadgeResponce: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getMessageBadge();
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  updateMessage(
    id: string,
    userReaction: 'noReaction' | 'like' | 'dislike' | null,
    readByUser: boolean
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .put<UpdateMessageResponce>(
        baseUrl + 'api/v2/supportTicket/user/' + id,
        {
          userReaction,
          readByUser,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ updateMessageResponce: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.updateMessage(id, userReaction, readByUser);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  sendVoteFaq(id: string, isLiked: boolean): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<SendVoteFaqResponce>(
        baseUrl + 'api/v2/faq/' + id + '/vote',
        {
          isLiked,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ voteFaqResponce: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.sendVoteFaq(id, isLiked);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  deleteVoteFaq(id: string): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .delete<DeleteVoteFaqResponce>(
        baseUrl + 'api/v2/faq/' + id + '/vote',

        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ deleteVoteFaqResponce: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.deleteVoteFaq(id);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  senMessage(
    text: string,
    faqId: string | null = null
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    let body = { text, faqId,type:'problem' };

    if (!faqId || faqId == '') {
      delete body.faqId;
    }
    return this.http
      .post<SuppotTicketsResponce>(
        baseUrl + 'api/v2/supportTicket/user',
        {
          ...body,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ sendMessageResponce: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.senMessage(text, faqId);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
}
